import cn from 'classnames';
import { ColumnProps } from 'antd/lib/table';
import { Icon } from 'Components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import styles from './GroupSummaryTable.module.scss';

const sortableTitle = (label: string) => (
	<span className={styles.colTitle}>
		<span>{label}</span>
		<Icon
			type="chevronDown"
			className={`${styles.colSortIcon} group-table-sort-icon`}
		/>
	</span>
);

const renderScoreCell = (value: number | undefined | null) => {
	if (value == null) return '—';
	const isGood = value >= 50;
	return (
		<span className={styles.scoreCell}>
			<span
				className={cn(
					styles.dot,
					isGood ? styles.dotBlue : styles.dotOrange
				)}
			/>
			{`${Math.round(value)}%`}
		</span>
	);
};

export function getGroupSummaryColumns(): ColumnProps<OverviewGroupSummary>[] {
	return [
		{
			title: sortableTitle('Group Name'),
			key: 'groupName',
			dataIndex: 'groupName',
			sorter: true
		},
		{
			title: sortableTitle('SAQ Compliance'),
			key: 'indexComposite',
			dataIndex: 'indexComposite',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: sortableTitle('Phishing'),
			key: 'phishingScore',
			dataIndex: 'phishingScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: sortableTitle('Training'),
			key: 'elearningScore',
			dataIndex: 'elearningScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: sortableTitle('Scanning'),
			key: 'spotCheckScore',
			dataIndex: 'spotCheckScore',
			render: renderScoreCell,
			sorter: true
		}
	];
}
